// @flow
import React from 'react'
import {setCombatantValue, setBattleValue} from '../../../redux-actions/battle-actions.js'
import {handleAnimationEnd, clearArenaAnimations, timeout} from './animation-lifecycle-utilities'

class AnimationHeadphones extends React.Component {

  props: {
    casterId: string,
    targetIds: Array<string>,
  };

  async runAnimationSeries() {

    //Change to Blue
    setBattleValue({
      arenaBackgroundStyle: "rgba(69,201,239,0.5)",
    });

    /* ----------- */ await timeout(100);

    //Start shaking
    setCombatantValue(this.props.casterId, {
      animationCssRule: "shake 2s infinite"
    });

    /* ----------- */ await timeout(900);

    //Stop shaking
    setCombatantValue(this.props.casterId, {
      animationCssRule: "none"
    });

    //Tell each target to also shake
    this.props.targetIds.forEach(targetId => {
      if (targetId !== this.props.casterId) { //Only do this for targets that are not the caster (who is already shaking)
        setCombatantValue(targetId, {
          animationCssRule: "shake 1.5s infinite"
        });
      }
    });

    /* ----------- */ await timeout(400);

    //Stop target shaking
    this.props.targetIds.forEach(targetId => {
      if (targetId !== this.props.casterId) {
        setCombatantValue(targetId, {
          animationCssRule: "none"
        });
      }
    });

    //Clear the background stuff
    clearArenaAnimations();


    /* ----------- */ await timeout(50);

    //Move on to next step
    handleAnimationEnd();
  }

  componentDidMount() {
    this.runAnimationSeries();
  }

  render() {
    return <div style={{position:'absolute'}} />;
  }
}

export default AnimationHeadphones;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/AnimationHeadphones.js